import { translate } from '../translations/translator';
import { ResourcesVariant, RESOURCE_TYPES, MediaVariant } from 'types';
const translateResources = key => translate('resources', key);

export const ResourcesSections = {
  ALLRESOURCES: {
    code: 'allResources',
    label: translateResources('allResources')
  },
  MYSTUFF: {
    code: 'myStuff',
    label: translateResources('myStuff')
  }
};
export const getSwitchFrameType = (
  variant: ResourcesVariant,
  mediaType: MediaVariant
): RESOURCE_TYPES.AV_PLAYER | RESOURCE_TYPES.IFRAME_PLAYER => {
  switch (variant) {
    case RESOURCE_TYPES.WOOD_PIECES:
    case RESOURCE_TYPES.WDT:
    case RESOURCE_TYPES.LNF:
    case RESOURCE_TYPES.PDF: {
      return RESOURCE_TYPES.IFRAME_PLAYER;
    }

    default: {
      return getPlayerByMediaType(mediaType);
    }
  }
};

const getPlayerByMediaType = (variant: MediaVariant) => {
  const clickAwayTypes = ['audio', 'video'];
  if (variant && clickAwayTypes.includes(variant)) {
    return RESOURCE_TYPES.AV_PLAYER;
  } else {
    return RESOURCE_TYPES.IFRAME_PLAYER;
  }
};

export const isAVPlayer = frameType => {
  return frameType === RESOURCE_TYPES.AV_PLAYER;
};
